<template>
  <div class="activity_index" ref="activityIndexRef">
    <!-- <img style="width: 100%;" src="@/assets/images/activity_bc.png" alt=""> -->
    <div class="header-info">
      <img class="activity-logo" src="@/assets/images/activity_logo.png" alt="">
      <img class="activity-header-img" src="@/assets/images/activity_qd.png" alt="">
    </div>
    <div class="points-info">
      <div class="point-left">Your Points：{{ this.detailsInfo.integral }}</div>
      <div class="point-right" @click="handleOper('viewPoints')">View Details</div>
    </div>
    <div class="earn-points">
      <div class="earn-title">Earn Points</div>
      <div class="sub-txt">Complete the tasks below to collect points.</div>
      <div class="sub-txt">Points will be automatically added to your account once earned</div>
    </div>
    <div class="oper-info">
      <img class="btn" src="@/assets/images/bind_product.png" alt="" @click="handleOper('bind')">
      <img class="btn" src="@/assets/images/upload_receipt.png" alt="" @click="handleOper('upload')">
      <img class="btn" src="@/assets/images/share_invite.png" alt="" @click="handleOper('share')">
    </div>
    <div class="task-rules">
      <div class="task-title">Task Rules：</div>
      <div class="task-txt"><span class="sub">Task 1：</span>Earn points by scanning the barcode at the<br />bottom of the package.</div>
      <div class="task-txt"><span class="sub">Task 2：</span>Earn points by uploading your sales receipt.</div>
      <div class="task-txt"><span class="sub">Task 3：</span>Earn points by inviting customers to join the<br />group.</div>
    </div>
    <div class="reward-record" @click="handleOper(null, '/activity/pointsInfo')">History</div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import { activityInfoApi, inviteCreateInviteCodeApi, activityEmployeeInfoApi } from '@/api'
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'Activity',
  data () {
    return {
      activityUrl: require('@/assets/images/nexa_img.svg'),
      detailsInfo: {}
    }
  },
  created () {
    // if (localStorage.getItem('linkUrl')) {
    //   localStorage.removeItem('linkUrl')
    // }
    this.getActivityInfo()
    this.sendWarning()
    this.getEmployeeInfo()
  },
  mounted () {
    // const viewHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    // const bottomBtn = document.getElementById('bottom-btn')
    // const botTabH = window.localStorage.getItem('tabH') || 50 activityBcColor
    // const activityBcImg = document.getElementById('activity-bc-img')
    // // console.log('`${viewHeight - (pageHeaderH  + Number(botTabH))}px`', `${viewHeight - (pageHeaderH  + Number(botTabH))}px`)
    // activityBcImg.style.height = `${viewHeight - bottomBtn.offsetHeight}px`
    // bottomBtn.style.bottom = `-${bottomBtn.offsetHeight - 20}px`
  },
  computed: {
    ...mapState({
      userInfo: 'myUserInfo'
    })
  },
  methods: {
    ...mapMutations(['setActivityInfo']),
    getActivityInfo () {
      Toast.loading({
        message: 'loading...',
        forbidClick: true,
        duration: 0
      })
      activityInfoApi(this.activityInfo.shareKey).then(res => {
        Toast.clear()
        this.setActivityInfo(res.data)
      })
    },
    handleProduct () {
      this.$router.push({
        path: '/activity/activityProduct',
        query: { scanType: 'activityProduct' }
      })
    },
    toUrl (url) {
      this.$router.push(url)
    },
    sendWarning () {
      const isLoginCode = localStorage.getItem('isLoginCode')
      if (isLoginCode === '1') {
        Dialog.alert({
          message: `${this.userInfo.user.nickName}，Your activity authorization code is '${this.userInfo.code}', Please keep it safe as it is needed for future access.`,
          confirmButtonText: 'I See',
          confirmButtonColor: '#ee541b'
        }).then(() => {
          // on close
        })
        localStorage.removeItem('isLoginCode')
      }
    },
    handleOper (type, url) {
      if (type === 'bind') {
        this.$router.push({
          path: '/activity/activityProduct',
          query: { scanType: 'activityProduct' }
        })
      } else if (type === 'upload') {
        this.$router.push('/activity/activityProduct?scanType=activityUpload')
      } else if (type === 'share') {
        Toast.loading({
          message: 'loading...',
          forbidClick: true,
          duration: 0
        })
        inviteCreateInviteCodeApi().then(res => {
          Toast.clear()
          if (res.data.status === 1) {
            this.$router.push('/activity/shareCommunity')
          } else {
            Toast('The event has not started.') // 活动未开启
          }
        }).catch(() => {
          Toast.clear()
        })
      } else if (type === 'viewPoints') {
        this.$router.push('/activity/pointsInfo?tabIndex=2')
      } else {
        this.$router.push(url)
      }
    },
    getEmployeeInfo () {
      Toast.loading({
        message: 'loading...',
        forbidClick: true,
        duration: 0
      })
      activityEmployeeInfoApi(this.userInfo.user.id).then(res => {
        Toast.clear()
        this.detailsInfo = res.data
        console.log('detailsInfo', this.detailsInfo)
      }).catch(() => {
        Toast.clear()
      })
    }
  }
}
</script>

<style lang="less">
.activity_index {
  position: relative;
  height: 100%;
  background: url('~@/assets/images/activity_bc.png') no-repeat center;
  background-size: 100% 100%;
  background-position-y: 100px;
  overflow: hidden;
  overflow-y: auto;
  .header-info {
    position: relative;
    width: 100%;
    height: 316px;
    .activity-header-img {
      width: 100%;
      height: 100%;
    }
    .activity-logo {
      position: absolute;
      left: 50%;
      top: 46px;
      transform: translateX(-50%);
      width: 80px;
      height: 20px;
    }
  }
  .points-info,
  .earn-points,
  .oper-info,
  .task-rules {
    width: 96%;
    margin: 0 auto;
  }
  // overflow-y: auto;
  .points-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 76px;
    padding: 0 16px;
    background: url('~@/assets/images/point-bc.png') no-repeat center;
    background-size: 100% 100%;
    font-weight: bold;
    .point-left {
      font-size: 15px;
      color: #ff8714;
    }
    .point-right {
      color: #fff;
      font-size: 12px;
      padding: 5px 10px;
      background-color: #ff8714;
      border-radius: 5px;
    }
  }
  .earn-points {
    text-align: center;
    color: #ff8714;
    margin-top: 16px;
    .earn-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 5px;
      // font-family: "Mont-HeavyDEMO";
    }
    .sub-txt {
      font-size: 11px;
      line-height: 15px;
    }
  }
  .oper-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
    margin-bottom: 16px;
    .btn {
      width: 31%;
    }
  }
  .task-rules {
    min-height: 100px;
    padding: 0 10px;
    padding-top: 20px;
    background: url('~@/assets/images/rules.png') no-repeat center;
    background-size: 100% 100%;
    font-size: 13px;
    color: #ff8714;
    .task-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 13px;
      // font-family: "Mont-HeavyDEMO";
    }
    .task-txt {
      margin-bottom: 5px;
      // font-family: "MONTSERRAT-REGULAR";
    }
    .sub {
      font-weight: bold;
    }
  }
  .reward-record {
    position: absolute;
    right: -10px;
    top: 40px;
    padding: 6px 16px;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    background-color: rgba(0, 0, 0, 0.4);
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
  }
}
</style>
